import React from 'react';
import ConfiguracionBase from '../../components/configuracion/ConfiguracionBase';

const HELP = {
  tips: [
    'El motivo indica por qué se detuvo el equipo: "Falla mecánica", "Falta de repuestos", "Reparación pendiente.',
    'Separá las detenciones por falla de las detenciones operativas: solo las primeras son responsabilidad del taller.',
    'Cuanto más consistente sea la carga del motivo, más confiable es el análisis de causas de parada.',
  ],
  nextSteps: [
    'Indicar el motivo cada vez que se registra una detención de equipo.',
    'Consultar el informe de fallas para ver qué motivos concentran más horas perdidas.',
  ],
};

const ConfiguracionMotivosDetencion = () => {
  return (
    <ConfiguracionBase
      apiEndpoint="motivosdetencion"
      titulo="Motivos de Detención"
      descripcion="Razones por las que un equipo es detenido"
      icon="fas fa-hand-paper"
      compact
      help={HELP}
    />
  );
};

export default ConfiguracionMotivosDetencion;